
///////////////// PRODUCT IMAGES /////////////////////
const headerElement = document.querySelector(".theme__header")?.clientHeight;
const productContent = document.querySelector(".product__content.product__wrapper");
productContent.style.top = headerElement + "px";

const btnSeeMore = document.querySelector("#images_grid_btn");
const productImageGrid = document.querySelector(".product__images_grid");

btnSeeMore?.addEventListener("click", () => {
    const hiddenItems = document.querySelectorAll(".swiper-slide[should-hide]");

    if (btnSeeMore.hasAttribute("data-see-more")) {
        hiddenItems.forEach(item => item.classList.remove("hidden"));

        btnSeeMore.setAttribute("data-see-less", "");
        btnSeeMore.removeAttribute("data-see-more");
        btnSeeMore.textContent = btnSeeMore.getAttribute("see-less-text");

    } else if (btnSeeMore.hasAttribute("data-see-less")) {
        hiddenItems.forEach(item => item.classList.add("hidden"));
        btnSeeMore.setAttribute("data-see-more", "");
        btnSeeMore.removeAttribute("data-see-less");
        btnSeeMore.textContent = btnSeeMore.getAttribute("see-more-text");

        productContent?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }
});

